module.exports = __webpack_public_path__ + "img/left-frame.921a51fd.png";